import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Container, Grid } from '@mui/material';
import styled from "@emotion/styled";

const drawerWidth = 240;
const navItems = [  {
  title: 'Buy Now',
  link: '#buynow'
},
{
  title: 'View Chart',
  link: '#chart'
},
{
  title: 'Tokenomics',
  link: '#tokenomics'
}
];

const MenuLinks = styled(Button)`
  Color:#27233A;
  font-size:18px;
  font-family:ManjariBold;
  font-weight:400;
  margin:0px 10px 0px 10px;
  padding: 22px 15px 22px 15px;
  border-radius:10px;
  text-transform:none;
  :hover{
    color:#FF9A55;
    background-image:url("./assets/menubg.png");
    background-size:contain;
    background-repeat:no-repeat;
    background-color:transparent;
  }
`
const MobileMenu = styled(ListItemText)`
  span {
    Color:#27233A;
    font-size:18px;
    font-family:ManjariBold;
    font-weight:600;
  }
  :hover{
    color:#FF9A55;
    background-image:url("./assets/menubg.png");
    background-size:contain;
    background-repeat:no-repeat;
    background-color:transparent;
  }
`

const NavBar = styled(AppBar)`
  position:absolute;
  padding-top: 15px;
  background:transparent;
  top:unset;
  box-shadow:none;
  .Tool{
    padding:0px;
  }
  @media (max-width: 749px){
    padding-top:10px;
  }
`
const MenuToggle = styled(IconButton)`
  .css-vubbuv{
    Color: #000;
    width:3rem;
    height:3rem;
  }
`

const DesktopMenuWrapper = styled(Grid)`
  justify-content: space-between;
  padding:10px 15px;
  border-radius:25px;
  @media (min-width: 2000px){
      padding:20px 30px;
    }
`

const LogoLink = styled.a`
    text-decoration:none;
    display:Flex;
`
const DesktopLogo = styled.img`

`
const NavBtn = styled.a`
    color:#fff;
    background:#FF9A55;
    text-decoration: none;
    font-family:ManjariRegular;
    font-size:18px;
    font-weight:400;
    border-radius:14px;
    text-align:center;
    padding: 10px 20px 7px 20px;
    margin-left:10px;
    @media (max-width: 600px){
            margin:20px 0px 0px 0px !important;
            }
`
const MobileLogo = styled.img`
      width: 150px;
      max-width: 150px;
      height: auto;
      margin-top: 6px;
`
const DrawerAppBar = (props) => {
  const { window, parrentMenuTheme } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <MobileLogo src="./assets/shihlogo.png" alt="" />
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton href={item.link} sx={{ textAlign: 'center' }}>
              <MobileMenu primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
        <div style={{marginTop: '15px'}}>
        <NavBtn>Join Telegram</NavBtn>
        </div>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Container >
    <Grid container sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavBar component="nav" style={{position:'inherit'}}>
        <Toolbar className='Tool'>
          <Grid item sm={12} xs={12} sx={{ mr: 2, display: { md: 'none' , xs: 'flex' } , justifyContent: 'space-between' }}>
            <LogoLink href="/">
            <MobileLogo src="./assets/shihlogo.png" alt="" />
            </LogoLink>
          <MenuToggle
            menutheme={parrentMenuTheme}
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            
          >
            <MenuIcon />
          </MenuToggle>
          </Grid>
          <DesktopMenuWrapper item xs={12} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' }  }}>
              <LogoLink href="/">
                <DesktopLogo src="./assets/shihlogo.png" alt="" />
              </LogoLink>
          <Box sx={{display: 'flex' , alignItems: 'center'}}>
            {navItems.map((item) => (
              <MenuLinks key={item.title} href={item.link} >
              {item.title}
              </MenuLinks>
            ))}
            <NavBtn href="https://t.me/shihtzuonbase" target="blank">Join Telegram</NavBtn>
          </Box>
          </DesktopMenuWrapper>
        </Toolbar>
      </NavBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Grid>
    </Container>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;